import { render, staticRenderFns } from "./MonthChart.vue?vue&type=template&id=54b59e98&scoped=true&"
import script from "./MonthChart.vue?vue&type=script&lang=js&"
export * from "./MonthChart.vue?vue&type=script&lang=js&"
import style0 from "./MonthChart.vue?vue&type=style&index=0&id=54b59e98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b59e98",
  null
  
)

export default component.exports